import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import React, { Component, Fragment } from 'react'
import { Row } from 'react-bootstrap'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { About } from './Pages/About/About'
import { Home } from './Pages/Home/Home'
import { Products } from './Pages/Projects/Products'
import Posts from './Pages/Posts/Posts'
import PostContent from './Pages/Posts/PostContent'
import { AttendanceComponent } from './Products/AttendancePlatform/AttendanceComponent'
import AccountDeletionRequest from './Products/AttendancePlatform/components/AccountDeletionRequest'

class App extends Component {
  render() {
    return (
      <div style={{ backgroundColor: 'white' }} className="w-100">
        <Router>
          <Fragment>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/products" exact component={Products} />
              <Route path="/posts" exact component={Posts} />
              <Route path="/post/:postId" component={PostContent} />
              <Route path="/about" exact component={About} />
              <Route path="/products/attendanceplatform/delete_data" component={AccountDeletionRequest}/>
              <Route path="/products/attendanceplatform" component={AttendanceComponent}/>
            </Switch>
          </Fragment>
        </Router>
        <Row />
      </div>
    )
  }
}

export default App
